import { getStateWithOnlyOneLevel } from './submitAQuestionSelectorsHelper';

function getSubmitAQuestionState(state) {
  return getStateWithOnlyOneLevel(state, 'submitAQuestionReducer');
}

export const getIsUserQuestionsLoading = (state) =>
  getSubmitAQuestionState(state).get('isUserQuestionsLoading');

export const getStatusMessage = (state) =>
  getSubmitAQuestionState(state).get('message');

export const getUserSubmittedQuestionsSelector = (state) =>
  getSubmitAQuestionState(state).get('submittedQuestions');

export const getDeleteStatusMessageSelector = (state) =>
  getSubmitAQuestionState(state).get('deleteStatusMessage');

export const getSelectedQuestionSelector = (state) =>
  getSubmitAQuestionState(state).get('selectedQuestion');
